export default __webpack_public_path__ + "static/media/rote_bomba_portrait.deccfb6a.jpg";